import { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { api, ApiError } from '../../lib/api.ts';
import { SiteLayout } from '../../components/SiteLayout.tsx';

export function SetPasswordPage() {
  const [params] = useSearchParams();
  const token = params.get('token') ?? '';
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [err, setErr] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    if (password !== confirm) {
      setErr('Passordene er ikke like.');
      return;
    }
    setLoading(true);
    setErr(null);
    try {
      await api.kontoSettPassord(token, password);
      setDone(true);
    } catch (error) {
      setErr((error as ApiError).message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <SiteLayout>
      <main className="flex justify-center px-4 py-12 sm:py-16">
        <div className="w-full max-w-sm bg-slate-900/60 border border-slate-800 rounded-2xl p-6">
          <h1 className="text-xl font-bold text-center mb-5">Sett passord</h1>

          {done ? (
            <div className="text-center">
              <div className="text-4xl mb-3">✅</div>
              <p className="text-sm text-slate-400 mb-5">
                Passordet er satt. Nå kan du logge inn.
              </p>
              <Link
                to="/logg-inn"
                className="inline-block bg-sky-600 hover:bg-sky-500 px-5 py-2.5 rounded-lg font-semibold"
              >
                Logg inn
              </Link>
            </div>
          ) : !token ? (
            <p className="text-sm text-amber-300 text-center">
              Mangler gyldig lenke. Åpne lenken fra e-posten på nytt, eller be om ny under «Glemt
              passord».
            </p>
          ) : (
            <form onSubmit={submit}>
              {err && (
                <div className="mb-4 text-red-300 bg-red-900/30 border border-red-800 rounded-lg p-3 text-sm">
                  {err}
                </div>
              )}
              <label className="block text-xs text-slate-400 mb-1">Nytt passord (minst 8 tegn)</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="new-password"
                minLength={8}
                required
                autoFocus
                className="w-full mb-3 px-3 py-2 bg-slate-950 border border-slate-700 rounded-lg"
              />
              <label className="block text-xs text-slate-400 mb-1">Gjenta passord</label>
              <input
                type="password"
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                autoComplete="new-password"
                minLength={8}
                required
                className="w-full mb-5 px-3 py-2 bg-slate-950 border border-slate-700 rounded-lg"
              />
              <button
                type="submit"
                disabled={loading}
                className="w-full bg-sky-600 hover:bg-sky-500 py-3 rounded-lg font-semibold disabled:opacity-60"
              >
                {loading ? 'Lagrer…' : 'Lagre passord'}
              </button>
            </form>
          )}
        </div>
      </main>
    </SiteLayout>
  );
}
